import { ProductActions } from '@spartacus/core';
import { CatalogActions } from '../actions';
import { ProductListLoadingState } from '../catalog-state';

export const initialState: ProductListLoadingState = {
  loading: false,
  loadingMore: false,
  loadingSuggestions: false,
};

export function reducer(
  state = initialState,
  action: ProductActions.ProductSearchAction | CatalogActions.LoadMoreProducts,
): ProductListLoadingState {
  switch (action.type) {
    case ProductActions.SEARCH_PRODUCTS: {
      // auxiliary со спартакусянского -- "вспомогательный запрос для отображения товаров в search suggestions"
      if (action.auxiliary) {
        return { ...state, loadingSuggestions: true };
      }

      return { ...state, loading: true };
    }

    case ProductActions.SEARCH_PRODUCTS_SUCCESS: {
      if (action.auxiliary) {
        return { ...state, loadingSuggestions: false };
      }

      return { ...state, loading: false };
    }

    case ProductActions.SEARCH_PRODUCTS_FAIL: {
      if (action.auxiliary) {
        return { ...state, loadingSuggestions: false };
      }

      return { ...state, loading: false, loadingMore: false };
    }

    case CatalogActions.LOAD_MORE_PRODUCTS: {
      return { ...state, loadingMore: true };
    }

    default: {
      return state;
    }
  }
}
